import React from "react";
import { connect } from "react-redux";
import Truncate from "react-truncate";

import { goToNotice } from "state/teachers/actions";

import Date from "components/Date";
import Card from "components/app/home/Card";
import BulletItem from "components/app/home/BulletItem";

class Notice extends React.Component {
  
  goToNotice = () => {
    this.props.goToNotice(this.props.notice.get("id"));
  }
  
  render() {
    const { notice } = this.props;
    return (
      <div className="teachers-home-notices__link" onClick={this.goToNotice}>
        <Card className="teachers-home-notices__notice">
          <BulletItem cssModifier="teachers">
            <div className="teachers-home-notices__notice-subject">
              <Truncate lines={1} trimWhitespace={true}>
                { notice.get("subject") }
              </Truncate>
            </div>
            <div className="teachers-home-notices__notice-timestamp">
              <Date date={notice.get("postedDate")} />
            </div>
          </BulletItem>
        </Card>
      </div>
    )
  }
  
}

export default connect(
  undefined,
  { goToNotice }
)(Notice);



// WEBPACK FOOTER //
// ./src/components/app/home/sections/teachers/Notice.js